﻿window.cStore = function (nomTable, data, onModified) {
    var Me = this
    this.key = "id_" + nomTable;
    var _disableOnModified = false
    this.array = (data ? data : []);

    //mInit()
    //function mInit() {
    //    if (nomTable == "reservation_hebergement") {
    //        Me.array = Me.array
    //            .slice()
    //            .sort((a, b) => a.date_debut <= b.date_debut ? -1 : 1);
    //    }
    //}

    // index interne pour perf
    this.index = new Map();
    this.normKey = (id) => {
        const n = parseInt(id);
        return isNaN(n) ? null : n;
    };
    for (let i = 0; i < this.array.length; i++) {
        const item = this.array[i];
        const id = this.normKey(item[this.key]);

        if (id !== undefined && id !== null) {
            this.index.set(id, item);
        }
    }


    const notify = () => {
        if (!_disableOnModified) {
            //mInit()
            if (onModified) onModified()
        }
    };

    this.insert = (item) => {
        const id = this.normKey(item[this.key]);
        if (this.index.has(id)) return;

        this.array.push(item);
        this.index.set(id, item);

        notify()
    };

    this.update = (id, patch) => {
        id = this.normKey(id);
        const item = this.index.get(id);
        if (!item) return;

        Object.assign(item, patch);

        notify()
    };

    this.remove = (id) => {
        id = this.normKey(id);
        const item = this.index.get(id);
        if (!item) return;

        this.index.delete(id);

        const i = this.array.indexOf(item);
        if (i >= 0) this.array.splice(i, 1);

        notify()
    };

    this.get = (id) => this.index.get(this.normKey(id));

    this.clearAndAdd = (items) => {
        // reset array
        this.array.length = 0;
        // reset index        
        this.index.clear();

        // add all items
        for (let i = 0; i < items.length; i++) {
            const item = items[i];
            const id = this.normKey(item[this.key]);

            this.array.push(item);
            this.index.set(id, item);
        }
        notify()
    };


    // 🔥 SYNC SERVER DATA
    this.sync = (serverData) => {
        _disableOnModified = true
        const newIds = new Set();
        // INSERT + UPDATE
        for (let i = 0; i < serverData.length; i++) {
            const newItem = serverData[i];
            const id = this.normKey(newItem[this.key]);
            newIds.add(id);
            const existing = this.index.get(id);
            if (!existing) {
                // INSERT
                this.insert(newItem);
            } else {
                // UPDATE IN PLACE (garde les refs)
                for (let prop in newItem) {
                    existing[prop] = newItem[prop];
                }
            }
        }

        // DELETE
        for (let i = this.array.length - 1; i >= 0; i--) {
            const item = this.array[i];
            const id = this.normKey(item[this.key]);
            if (!newIds.has(id)) {
                this.remove(id);
            }
        }

        _disableOnModified = false
        notify()
    };

    this.mAddOrMajData = function (itemData) {
        _disableOnModified = true
        const id = this.normKey(itemData[this.key]);
        const existing = this.index.get(id);
        if (!existing) {
            // INSERT
            this.insert(itemData);
        } else {
            // UPDATE IN PLACE (garde les refs)
            for (let prop in itemData) {
                existing[prop] = itemData[prop];
            }
        }
        _disableOnModified = false
        notify()
    }

}